/* eslint-env browser */
import tracking from '@finn-no/analytics';

function trackItemClick() {
    tracking.trackEventLater({
        analyticsName: 'search.repeat-recent-search.click',
        ecType: 'SEARCH',
        ecCategory: 'FrontpageLastSearchesClick',
    });
}

class LastSearchesBox {
    constructor(ele) {
        this.containerEle = ele;
        this.summaryButtonEle = ele.querySelector('[data-summary-button]');
        this.chevronIconEle = ele.querySelector('[data-chevron-icon]');
        this.emptyMessageEle = ele.querySelector('[data-empty-message]');
        this.contentsEle = ele.querySelector('[data-contents]');
        this.linksListEle = ele.querySelector('[data-links-list]');
        this.clearButtonEle = ele.querySelector('[data-clear-button]');
        this.baseUrl = ele.getAttribute('data-lastsearch-delete-url');
        this.deviceType = ele.getAttribute('data-device-type');
    }

    init() {
        this.initExpandable();
        this.initClearButton();
        this.initTracking();
    }

    initExpandable() {
        if (this.deviceType === 'desktop') {
            // Only there on mobile
            return;
        }

        if (this.summaryButtonEle) {
            this.summaryButtonEle.addEventListener('click', () => {
                const isOpen =
                    this.summaryButtonEle.getAttribute('aria-expanded') !==
                    'true';

                this.contentsEle.classList.toggle('h-0', !isOpen);
                this.contentsEle.classList.toggle('invisible', !isOpen);
                this.contentsEle.style.height = isOpen ? 'auto' : '0px';
                this.contentsEle.style.overflow = isOpen ? null : 'hidden';

                this.chevronIconEle.classList.toggle('-rotate-180', isOpen);

                this.contentsEle.setAttribute(
                    'aria-hidden',
                    !isOpen ? 'true' : 'false',
                );
                this.summaryButtonEle.setAttribute(
                    'aria-expanded',
                    isOpen ? 'true' : 'false',
                );
            });
        }
    }

    initClearButton() {
        if (this.baseUrl && this.clearButtonEle) {
            this.clearButtonEle.addEventListener('click', (evt) => {
                evt.preventDefault();
                window.fetch(this.baseUrl, {
                    method: 'DELETE',
                    credentials: 'include',
                });
                this.clearButtonEle.remove();
                this.linksListEle.remove();
                this.emptyMessageEle.classList.remove('hidden');
            });
        }
    }

    initTracking() {
        const links = this.containerEle.querySelectorAll(
            'a[data-last-search-link]',
        );
        links.forEach((link) => link.addEventListener('click', trackItemClick));
    }
}

export default LastSearchesBox;
